// types.js
export const ADD_POST = 'ADD_POST';
export const DELETE_POST = 'DELETE_POST';
export const FETCH_POST = 'FETCH_POST';
export const CREATE_VOTE = 'CREATE_VOTE';
export const CREATE_VOTE_ERROR = 'CREATE_VOTE_ERROR';


